<div class="widgets-wrapper">
  <div class="widget-container gallery">
    <app-widget-container [title]="'Creative Gallery'" [control]="gallerySort" [selectMode]="SelectMode.SINGLE"
      [selectWidth]="'248px'">
      <div class="gallery-inner">
        <div class="gallery-main">
          <div class="gallery-content">
            @if (creativeGalleryData.total) {
            <app-creative-gallery [data]="creativeGalleryData.creativesData" [loading]="loading"
              [brandskeys]="getAllBrandsKeys()" [getterName]="'getCompetitorCreativeCard'"
              (requestPageChange)="onCreativeModalEdgeNav($event)">
            </app-creative-gallery>
            } @else if (loading) {
            <app-loader></app-loader>
            } @else {
            <app-no-data-widget [icon]="'svg/bar-chart.svg' | assetVersion" title="No Creatives Found"
              message="Try adjusting your filters.">
            </app-no-data-widget>
            }
          </div>
        </div>
        <div class="filters-wrapper">
          <div class="filters-container">
            <div class="filter-item" [class.selected]="isSortOpen" (click)="openSortPanel.set({})">
              <img [src]="'svg/up-and-down-arrows.svg' | assetVersion" alt="Sort icon">
              <span>Sort</span>
              <div class="messaging-gallery-sort-dropdown">
                <app-select-menu #sortSelectMenu [selectMode]="SelectMode.ATTACHED_SINGLE" [searchable]="false"
                  [selectAllAndClearOptions]="false" [control]="gallerySort" [items]="gallerySortOptions"
                  [dropDownSide]="'left'" [openPanel]="openSortPanel" [customHeaderTemplate]="sortHeaderTemplate"
                  (onApply)="onSortFieldChange()">
                </app-select-menu>
              </div>
              <ng-template #sortHeaderTemplate>
                <div class="sort-dropdown-title">Sort</div>
              </ng-template>
            </div>
            <div class="filter-item" [class.selected]="isThemeOpen" (click)="openThemePanel.set({})">
              <span class="open-indicator" *ngIf="themeControl.value.length > 0"></span>
              <img [src]="'svg/messaging-with-lines.svg' | assetVersion" alt="Filter icon">
              <span>Theme</span>
              <div class="messaging-gallery-sort-dropdown messaging-gallery-theme-dropdown">
                <app-select-menu #themeSelectMenu [selectMode]="SelectMode.ATTACHED_MULTI" [searchable]="false"
                  [selectAllAndClearOptions]="true" [control]="themeControl" [items]="themeOptions"
                  [openPanel]="openThemePanel" [customHeaderTemplate]="themeHeaderTemplate" (onApply)="onThemeChange()">
                </app-select-menu>
              </div>
              <ng-template #themeHeaderTemplate>
                <div class="sort-dropdown-title">Theme</div>
              </ng-template>
            </div>
            <app-volume-filter [variant]="'sidebar'" (filterApplied)="onCreativeGalleryVolumeFilter($event)"></app-volume-filter>
            <div class="filter-item" [class.disabled]="isExportDisabled" (click)="onExport()"
                [tp]="isExpiredUser ? PremiumTooltipTemplate : null" [tpClassName]="'custom-tooltip'" [tpPlacement]="'bottom'" [tpOffset]="[-160, 0]">
              <ng-template #PremiumTooltipTemplate> <app-premium-tooltip [text]="tooltips.premium.exportFile"></app-premium-tooltip> </ng-template>
              <img [src]="'svg/download.svg' | assetVersion" alt="Export icon">
              <span>Export</span>
            </div>
          </div>
        </div>
      </div>
    </app-widget-container>
    <div *ngIf="creativeGalleryData.total" class="paginator-container">
      <div class="page-size-selector">
        <span class="page-size-label">Creatives per Page:</span>
        <app-select-menu [selectMode]="SelectMode.SINGLE" [searchable]="false" [width]="'74px'"
          [selectAllAndClearOptions]="false" [control]="pageSizeControl" [items]="pageSizeSelectOptions"
          (onApply)="onPageSizeChange($event)">
        </app-select-menu>
      </div>
      <app-paginator #creativeGalleryPaginator [length]="creativeGalleryData.total" [pageSize]="pageSize"
        [initialPage]="initialPage" (page)="onCreativeGalleryPageChange($event)">
      </app-paginator>
    </div>
  </div>
</div>